import { render, staticRenderFns } from "./FullWidthLayout.vue?vue&type=template&id=ef2da7c0&"
import script from "./FullWidthLayout.vue?vue&type=script&lang=js&"
export * from "./FullWidthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports